module.exports = __webpack_public_path__ + "img/c1.870c9e28.png";